module.exports = __webpack_public_path__ + "media/app/img/mac-os-logo-db735c3ee2a93ab1349a52bab1a1a961.png";